import { TemplateRef, } from "@angular/core";
import { ApiService } from "../../../services/api.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { TranslateService } from "@ngx-translate/core";
var ProductListDetailComponent = (function () {
    function ProductListDetailComponent(apiService, modalService, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.translate = translate;
        this.title = "";
        this.errorMessage = null;
        this.errorMsgForShow = null;
        this.errorMsgForShows = null;
        this.passwordPlaceHolder = "";
        this.parent = null;
        this.departmentChoices = [];
    }
    ProductListDetailComponent.prototype.open = function (parent, selectedProduct) {
        this.parent = parent;
        this.errorMessage = null;
        this.departmentChoices = this.parent.departmentChoices;
        if (selectedProduct) {
            this.currentProduct = selectedProduct;
            this.productId = selectedProduct.product_id;
            (this.productNameEng = selectedProduct.name_en),
                (this.productNameThai = selectedProduct.name_th),
                (this.departments = selectedProduct.departments || []);
            var name_1 = this.currentLang === "th" ? this.productNameThai : this.productNameEng;
            this.title =
                this.translate.instant("PRODUCT.LIST.MODAL.TITLE") + " : " + name_1;
        }
        else {
            this.title = this.translate.instant("PRODUCT.LIST.MODAL.ADD-USER");
        }
        this.modalRef = this.modalService.show(this.modalTemplate, {
            backdrop: "static",
            class: "modal-dialog-centered"
        });
    };
    ProductListDetailComponent.prototype.ngOnInit = function () { };
    ProductListDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.currentLang === "th") {
            var errorField = [];
            this.errorMessage = null;
            if (!this.productId) {
                errorField.push("รหัสผลิตภัณฑ์");
            }
            if (!this.productNameEng || !this.productNameThai) {
                errorField.push("ชื่อผลิตภัณฑ์");
            }
            if (errorField.length > 0) {
                this.errorMessage = "โปรดกรอก " + errorField.join(", ") + " ให้ถูกต้อง";
                return;
            }
        }
        else {
            var errorField = [];
            this.errorMessage = null;
            if (!this.productId) {
                errorField.push("Product ID");
            }
            if (!this.productNameEng || !this.productNameThai) {
                errorField.push("Product name");
            }
            if (errorField.length > 0) {
                this.errorMessage =
                    "Please fill " + errorField.join(", ") + " correctly";
                return;
            }
        }
        var payload = {
            product_id: this.productId,
            name_en: this.productNameEng,
            name_th: this.productNameThai,
            departments: this.departments || [],
        };
        var request$ = this.currentProduct
            ? this.apiService.updateProduct(this.currentProduct.id, payload)
            : this.apiService.createProduct(payload);
        request$.subscribe(function () {
            if (_this.currentProduct) {
                _this.sniff("UPDATE_PRODUCT", _this.productId + ":" + _this.productNameEng);
            }
            else {
                _this.sniff("CREATE_PRODUCT", _this.productId + ":" + _this.productNameEng);
            }
            _this.parent.reload();
            _this.modalRef.hide();
            _this.clearData();
        }, function (error) {
            console.log(error);
            _this.checkErrorMsg(error);
        });
    };
    ProductListDetailComponent.prototype.checkErrorMsg = function (error) {
        this.errorMessage = this.apiService.getErrorMessage(error);
    };
    ProductListDetailComponent.prototype.clearData = function () {
        this.errorMessage = undefined;
        this.errorMsgForShows = undefined;
        this.productId = undefined;
        this.productNameEng = undefined;
        this.productNameThai = undefined;
        this.departments = [];
        this.currentProduct = undefined;
    };
    ProductListDetailComponent.prototype.close = function () {
        this.modalRef.hide();
        this.clearData();
    };
    ProductListDetailComponent.prototype.checkErrorAllMsg = function (error) {
        this.errorMsgForShows = this.apiService.getErrorMessage(error);
        if (this.translate.currentLang === "en") {
            this.errorMessage = this.errorMsgForShows[0];
        }
        else {
            this.errorMessage = this.errorMsgForShows[1];
        }
    };
    ProductListDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: "MANAGE_PRODUCT",
            target: target,
        };
        this.apiService.sniff(data).subscribe(function (res) { });
    };
    Object.defineProperty(ProductListDetailComponent.prototype, "currentLang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    return ProductListDetailComponent;
}());
export { ProductListDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list-detail/product-list-detail.component.ts.pre-build-optimizer.js